import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/ui/Button";

export default function TestCompleted() {
  const navigate = useNavigate();

  const handleViewScore = () => {
    navigate("/candidate/results");
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full mx-4">
        <div className="text-center">
          <div className="mb-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg 
                className="w-8 h-8 text-green-600" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M5 13l4 4L19 7" 
                />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Test Completed
            </h1>
            <p className="text-gray-600">
              Congratulations! You have successfully completed the mock test.
            </p>
          </div>
          
          <Button
            variant="default"
            size="lg"
            iconName="Eye"
            iconPosition="left"
            onClick={handleViewScore}
            className="w-full"
          >
            View Score
          </Button>
        </div>
      </div>
    </div>
  );
}
